import GetFundedAuth from "./GetFundedAuth";

export default GetFundedAuth;
